import { fetcher } from "helpers/fetcher";

import { TGetStaffSettingRes } from "./types";
import { API_HEADER } from "../constants";
import { ENDPOINT } from "../endpoint";

export const getStaffSetting = async (userId: string) => {
  return await fetcher<TGetStaffSettingRes, any>(
    ENDPOINT.USER.GET_STAFF_SETTING,
    {
      headers: {
        [API_HEADER.VERSION]: ENDPOINT.USER.GET_STAFF_SETTING.version,
        [API_HEADER.USER_ID]: userId,
      },
    }
  );
};

export const queryGetStaffSetting = async (userId: string) => {
  return (await getStaffSetting(userId)).data;
};

queryGetStaffSetting._key = (userId: string) => [
  ENDPOINT.USER.GET_STAFF_SETTING.url,
  userId,
];
